import store from '@/store';

export const handleHelpWidgetClosing = async (to, from, next) => {
  if (store.getters['help/showHelpDrawer']) {
    store.commit('help/toggleDrawer');
  }
  return next();
};
